/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

/**
 * Profile role enumeration for user access within an account.
 */
export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];


export const ProfileRole = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
} as const;
